import { Filter } from "@/lib/filterable";
import {
  MrfiktivAttorneyDetailsGen,
  MrfiktivBrokerDetailsGen,
  MrfiktivCreateInsuranceDtoGen,
  MrfiktivCreateLeasingDetailsDtoGen,
  MrfiktivCreatePoliceDetailsDtoGen,
  MrfiktivUpdateReportDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { IReport } from "./report.entity";
import { PoliceDetails } from "./police.entity";
import { LeasingDetails } from "./leasing.entity";

class ReferencesBase implements Pick<MrfiktivUpdateReportDtoGen, "policeDetails" | "leasing" | "broker" | "attorney"> {
  _report?: Partial<IReport> | null = null;

  policeDetails?: MrfiktivCreatePoliceDetailsDtoGen | null = null;

  leasing?: MrfiktivCreateLeasingDetailsDtoGen | null = null;

  isBroker: boolean;
  broker?: MrfiktivBrokerDetailsGen | null = null;

  isAttorney: boolean;
  attorney?: MrfiktivAttorneyDetailsGen | null = null;

  isInsurance: boolean;
  insurance?: MrfiktivCreateInsuranceDtoGen | null = null;

  /**
   *
   * @param obj
   */
  constructor(obj?: Partial<IReport>) {
    this._report = obj;

    this.policeDetails = obj?.policeDetails ?? new PoliceDetails({ department: "", fileReference: "" });
    this.leasing = obj?.leasing ?? new LeasingDetails({ company: "", claimNumber: "" });
    this.broker = obj?.broker ?? ({ name: "", number: "" } as MrfiktivBrokerDetailsGen);
    this.isBroker = Boolean(obj?.broker?.name || obj?.broker?.number);
    this.attorney = obj?.attorney ?? ({ name: "", number: "" } as MrfiktivAttorneyDetailsGen);
    this.isAttorney = Boolean(obj?.attorney?.name || obj?.attorney?.number);
    this.insurance = obj?.insurances?.[0] ?? { name: "", number: "" };
    this.isInsurance = Boolean(this.insurance.name);
  }

  get dto(): Pick<MrfiktivUpdateReportDtoGen, "policeDetails" | "leasing" | "insurances" | "broker" | "attorney"> {
    let insurances = [];

    if (this._report && this._report.insurances?.length) {
      insurances = this._report.insurances;

      const insurance = insurances[0];
      if (insurance) {
        insurance.name = this.insurance?.name ?? "";
        insurance.number = this.insurance?.number;
      }
    } else {
      insurances = [this.insurance];
    }

    return {
      policeDetails: this.policeDetails?.isRecorded ? this.policeDetails : null,
      leasing: this.leasing?.isLeasing ? this.leasing : null,
      broker: this.isBroker ? this.broker : null,
      attorney: this.isAttorney ? this.attorney : null,
      insurances: this.isInsurance ? (this.insurance ? [this.insurance] : []) : []
    };
  }
}

type IReferences = ReferencesBase;
const References = Filter.createForClass(ReferencesBase);

export { IReferences, References };
